import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../../../../shared/kompaktdarstellung/kompakt-darstellung-template.component';
import {
  GrundpfandrechtMasterIdMeta,
  HistInfo,
  PfandrechtVersionDetailEntryMeta,
  RechteId,
  RechteIdMeta,
  RechtMasterId,
  RechtMasterIdMeta,
  RechtVersionListEntry
} from '../../../../core/gb-api';
import { LinkComponent, NavTarget } from '../../../../shared/components/link/link.component';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { DecimalPipe, NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../../../shared/services/location-strategy/component-location-strategy';
import { keysToTranslate } from '../../../../../i18n/keys-to-translate';
import { FormatRechteIdPipe } from '../../../../shared/pipes/format/format-rechte-id.pipe';
import { NamenInhaberPfandrechtartPipe } from '../../../../shared/pipes/simple/namen-inhaber-pfandrechtart.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-kompakt-grundpfandrecht-icp',
  imports: [
    DecimalPipe,
    FormatRechteIdPipe,
    LinkComponent,
    NamenInhaberPfandrechtartPipe,
    TranslateNamePipe,
    TranslatePipe,
    NgTemplateOutlet
  ],
  templateUrl: './kompakt-grundpfandrecht-icp.component.html'
})
export class KompaktGrundpfandrechtIcpComponent extends KompaktdarstellungTemplateComponent implements OnInit {
  @Input()
  masterId: RechtMasterId | RechtMasterIdMeta | GrundpfandrechtMasterIdMeta;
  @Input()
  rechteId: RechteId | RechteIdMeta;
  @Input()
  version: RechtVersionListEntry | PfandrechtVersionDetailEntryMeta;
  @Input()
  pfandstelle: number;

  @Input()
  histInfo: HistInfo;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;
  text: string = '';
  navTargets = NavTarget;

  constructor(formatService: FormatConfigService, location: PlatformLocation, locationStrategy: ComponentLocationStrategy) {
    super(formatService, 'GRUNDPFANDRECHT', location, locationStrategy);
    keysToTranslate<string>(['EINZELPFANDRECHT_KURZ', 'GESAMTPFANDRECHT_KURZ', 'TEILPFANDRECHT_KURZ', 'GESAMTTEILPFANDRECHT_KURZ']);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.histInfo) {
      this.histInfo = this.version.histInfo;
    }
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'GRUNDPFANDRECHT_TYP00');
    this.bindTemplates(this.typ01Template, 'GRUNDPFANDRECHT_TYP01');
    this.bindTemplates(this.typ02Template, 'GRUNDPFANDRECHT_TYP02');
  }

  getQueryParams(version: RechtVersionListEntry | PfandrechtVersionDetailEntryMeta) {
    return { id: this.masterId.id, versionId: version.id.id };
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }
}
